import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="px-6 lg:px-12 py-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        {/* Mobile: Stack vertically, Desktop: Row */}
        <div className="flex flex-col items-center gap-6">
          {/* Logo */}
          <div className="flex items-center gap-0.5">
            <img 
              src="/revocut-logo.png" 
              alt="RevoCut Logo" 
              className="w-8 h-8 object-contain"
            />
            <span className="font-bold text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>REVOCUT</span>
          </div>
          
          {/* Navigation Links - Wrap on mobile */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-sm text-gray-400">
            <button onClick={() => navigate('/services')} className="hover:text-white transition-colors">Services</button>
            <button onClick={() => navigate('/team')} className="hover:text-white transition-colors">Über uns</button>
            <button onClick={() => navigate('/freelancer/login')} className="hover:text-white transition-colors">Freelancer Login</button>
            <button onClick={() => navigate('/admin')} className="hover:text-white transition-colors">Admin</button>
          </div>

          {/* Legal Links - Separate row on mobile */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-sm text-gray-500">
            <button onClick={() => navigate('/impressum')} className="hover:text-white transition-colors">Impressum</button>
            <button onClick={() => navigate('/datenschutz')} className="hover:text-white transition-colors">Datenschutz</button>
            <button onClick={() => navigate('/widerruf')} className="hover:text-white transition-colors">Widerruf</button>
            <button onClick={() => navigate('/agb')} className="hover:text-white transition-colors">AGB</button>
          </div>

          {/* Copyright */}
          <p className="text-sm text-gray-500">© 2026 RevoCut Media</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
